var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.25469V8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8V9.25469C14.8662 8.46381 13.4872 8 12 8C10.5128 8 9.13383 8.46381 8 9.25469ZM7.99963 12H8V11.9995C8.91223 10.7853 10.3644 10 12 10C13.6356 10 15.0878 10.7853 16 11.9995V12H16.0004C16.6281 12.8357 17 13.8744 17 15C17 17.7614 14.7614 20 12 20C9.23858 20 7 17.7614 7 15C7 13.8744 7.37194 12.8357 7.99963 12ZM6 11.3924V8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8V11.3924C18.6348 12.446 19 13.6803 19 15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15C5 13.6803 5.36518 12.446 6 11.3924ZM12 13C13.1046 13 14 13.8954 14 15C14 16.1046 13.1046 17 12 17C10.8954 17 10 16.1046 10 15C10 13.8954 10.8954 13 12 13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.54ae90b64ef14ba0280828344da492a9.svg";
export { ForwardRef as ReactComponent };